import { render, staticRenderFns } from "./ListEstablishmentTransferPage.vue?vue&type=template&id=0154a48a"
import script from "./ListEstablishmentTransferPage.vue?vue&type=script&lang=js"
export * from "./ListEstablishmentTransferPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports